import { render, staticRenderFns } from "./WorkDistributionsPanel.vue?vue&type=template&id=6457d876"
import script from "./WorkDistributionsPanel.vue?vue&type=script&lang=js"
export * from "./WorkDistributionsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkDistributionsPanel.vue?vue&type=style&index=0&id=6457d876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports